import React from 'react'
import { Grid } from 'semantic-ui-react'
import InputField from '../../../commonComponents/formComponents/inputField'
import DropDown from '../../../commonComponents/formComponents/dropDown'
import { useSelector, useDispatch } from 'react-redux'
import { TranslateContext } from '../TranslateContext'
import DeleteIcon from '../../../commonComponents/deleteIcon'
import CopyRepElement from '../../../GB_App/formSections/itemsTab/copyRepElement'
import { useCurrentShipmentType } from '../../../hooks'
// import validate from 'validate.js'
// import { createRepElemMsgStructure } from '../../util/itemsTabValidation'
// import * as ActionTypes from '../../actions/actionTypes'

const PreviousDocumentsDetails = ({
  item: { docType, docRef, docDecl,line,id },
  prevDocIdx,
  lineItemIndex,
  invoiceIndex,
  // prevDocPattern,
  isDMS,
  isItemsTab,
  isImportShipment,
  deleteData,
  updateData,
  saveData,
  copyData,
  render,
  docTypeLineValidation,
  initItemsTabValidation
}) => {
  // const dispatch = useDispatch()
  const prevDocTypeList = useSelector((state) => state.DropDownValues.prevDocTypes)
  const prevDocumentList=useSelector((state) => state.DropDownValues.agsExpPrevDocument)

  const lineErr = useSelector((state)=>state?.ValidationErrors.items?.[`invoice${invoiceIndex+1}_lineItem${lineItemIndex+1}_prevDoc${prevDocIdx+1}_line`]) 
  const translate = React.useContext(TranslateContext).translate

  const renderForm=render && render({docType,line,id,prevDocIdx, lineErr})
  const width=renderForm ? 4 : 5

  const { isDisabled } = useCurrentShipmentType()
  return (
    <Grid.Row>
      {(isItemsTab) && (
              <Grid.Column width='1' style={{textAlign:'center'}}>
              <CopyRepElement
                title={isDMS ? 'DOC_PROCEDURE' : 'PREVIOUS_DOCUMENT'}
                request={{ docType, docRef, docDecl,line }}
                callback={copyData}
                isFormDisabled={isDisabled}
              />
            </Grid.Column>
      )}
      <Grid.Column width={width} className='divFormFeild border-bottom  b-rw-0'>
        <DropDown
          id={`docType${id}`}
          className='field-bg dropdown100 addInfoCode'
          labelClass='text-none'
          label='DOC TYPE'
          isLabel={true}
          data={prevDocTypeList}
          clearable
          value={docType}
          onChange={(value) => {
            if(docTypeLineValidation) docTypeLineValidation(prevDocIdx,value,line)
             if(renderForm){
              saveData({ id, docType: value,line:" " })
              updateData(id, { docType: value?.trim(),line:""})
             }
             else{
            saveData({ id, docType: value })
            updateData(id, { docType: value?.trim() })
             }
          }} 
        />
      </Grid.Column>

      <Grid.Column width={ (isItemsTab) ? width-1 : width} className='divFormFeild  border-bottom b-rw-0'>
        <InputField
          isLabel={false}
          id={`docRef${id}`}
          type='text'
          label={`DOC ${translate('REFERENCE', { ns: ['default', 'lineItem'] })}`}
          value={docRef}
          className={'field-bg'}
          clearInput={false}
          onChange={(value) => updateData(id, { docRef: value })}
          onBlur={() => saveData({ id, docRef: docRef || ' ' })}
        />
      </Grid.Column>
      <Grid.Column width={width} className='divFormFeild   border-bottom '>
        <DropDown
          id={`decDoc${id}`}
          className='field-bg dropdown100 addInfoCode'
          labelClass='text-none'
          isLabel={true}
          label={translate('DOC_PROCEDURE')}
          data={prevDocumentList}
          value={docDecl}
          clearable
          onChange={(value) =>{
             updateData(id, { docDecl: value?.trim() })
             saveData({ id, docDecl: value})
            }
          }

        />
      </Grid.Column>
      {renderForm}
      <Grid.Column width='1' className='icon-delete-add-info'>
        <DeleteIcon id={`previous-docs-delete-${id}`}  onClick={() => deleteData(id, initItemsTabValidation)}/>
       
      </Grid.Column>
    </Grid.Row>
  )
}

export default React.memo(PreviousDocumentsDetails)
